import { useTranslation } from 'react-i18next'
import './TenantStatistics.scss'
interface Props {
  counters: { customersCount: number; activeUsers: number; inactiveUsers: number }
}
export function TenantStatistics({ counters }: Props) {
  const { t } = useTranslation('common')
  return (
    <div className="box groupArea tenantStats">
      <div className="statsRow">
        <div className="stat">
          <i className="icon-customers" />
          <div className="info">
            <span className="counter">{counters.customersCount}</span>
            <span className="label">{t('COMPANIES')}</span>
          </div>
        </div>
        <div className="stat">
          <i className="icon-users active" />
          <div className="info">
            <span className="counter">{counters.activeUsers}</span>
            <span className="label">{t('ACTIVE_USERS')}</span>
          </div>
        </div>
        <div className="stat inactive">
          <i className="icon-users " />
          <div className="info">
            <span className="counter">{counters.inactiveUsers}</span>
            <span className="label">{t('INACTIVE_USERS')}</span>
          </div>
        </div>
      </div>
    </div>
  )
}
